
/**
 * Format specified message with timestamp and app name.
 * @param message 
 */
export function formatLog(message: string): string {

    // Compose output string with timestamp and appname
    const formattedMessage = `${new Date().toLocaleTimeString()} [CAP]: ${message}`;

    return formattedMessage;     
}

export function formatNumber(number: number, digits: number = 0) {
    if (typeof digits !== 'number' || digits === null || digits === undefined) {
        digits = 0;
    }

    if (typeof number === 'number' && !isNaN(number)) {
        return number.toFixed(digits).replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    return "";
}


// WEBPACK FOOTER //
// ./ClientApp/app/utils/formatter.ts